import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { productSlice } from './product';
import { HealthQuoteStoreState } from './types';
import { userSlice } from './user';

export const useHealthQuoteStore = create<HealthQuoteStoreState>()(
  immer(
    devtools((...a) => ({
      ...userSlice(...a),
      ...productSlice(...a)
    }))
  )
);
